import { Fragment, useState } from "react";
import { Dialog, Disclosure, Popover, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import { setSearch, useGetStyleCategoriesQuery } from "@/store";
import { useTranslations } from "next-intl";

const filters = [
  {
    id: "category",
    name: "Filter",
    options: [
      { value: "minimalist", label: "Minimalist" },
      { value: "colorful", label: "Colorfull" },
    ],
  },
];

export const Filter = ({ setFilterIds }) => {
  const dispatch = useDispatch();
  const [selectedValues, setSelectedValues] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchName, setSearchName] = useState("");

  const { data } = useGetStyleCategoriesQuery();
  const handleFilterChange = (value, isChecked) => {
    setSelectedValues((prevSelectedValues) => {
      const updatedValues = isChecked
        ? [...prevSelectedValues, value]
        : prevSelectedValues.filter((item) => item !== value);
      setFilterIds(updatedValues);
      return updatedValues;
    });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(setSearch(searchName));
  };
  const t = useTranslations()
  return (
    <div className=" bg-transparent">
      <div className="mx-auto max-w-3xl px-0 sm:px-4 text-center  lg:max-w-7xl ">
        <section
          aria-labelledby="filter-heading"
          className="py-4"
        >
          <div className="flex items-center justify-between">
            <form onSubmit={(e) => onSubmit(e)} className="mr-2 w-full block ">
              <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                {t("search")}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  className="block w-full md:p-4 p-3 md:pl-10 pl-8 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-mainLightPurple focus:border-mainLightPurple dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  placeholder={t("searchTemplate")}
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
                <button
                  type="submit"
                  onSubmit={(e) => onSubmit(e)}
                  className="text-white font-semibold absolute right-2.5 md:bottom-2.5 bottom-[5px] bg-mainLightPurple hover:bg-mainLightPurpleHover rounded-lg text-sm px-4 py-2"
                >
                  {t("search")}
                </button>
              </div>
            </form>
            <button
              type="button"
              className="inline-block text-sm font-medium text-gray-700 hover:text-gray-900 sm:hidden"
              onClick={() => setOpen(true)}
            >
              {t("filters")}
            </button>

            <Popover.Group className="hidden sm:flex sm:items-baseline sm:space-x-8">
              <Popover
                as="div"
                key={"1"}
                id={`desktop-menu`}
                className="relative inline-block text-left"
              >
                <div>
                  <Popover.Button className="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none">
                    <span>{t("styles")}</span>
                    {selectedValues.length > 0 ? (
                      <span className="ml-1.5 rounded bg-gray-200 px-1.5 py-0.5 text-xs font-semibold tabular-nums text-gray-700">
                        {selectedValues.length}
                      </span>
                    ) : null}
                    <ChevronDownIcon
                      className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                  </Popover.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Popover.Panel className="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white p-4 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <form className="space-y-4">
                      {data?.data?.map((option, optionIdx) => (
                        <div key={option.value} className="flex items-center">
                          <input
                            id={`filter-${option.id}-${optionIdx}`}
                            name={`${option.id}[]`}
                            defaultValue={option.name}
                            type="checkbox"
                            checked={selectedValues.includes(option.id)}
                            onChange={(e) =>
                              handleFilterChange(option.id, e.target.checked)
                            }
                            className="h-4 w-4 rounded border-gray-300 text-mainLightPurpleText  focus:ring-mainLightPurple"
                          />
                          <label
                            htmlFor={`filter-${option.id}-${optionIdx}`}
                            className="ml-3 whitespace-nowrap pr-6 text-sm font-medium text-gray-900"
                          >
                            {option.name}
                          </label>
                        </div>
                      ))}
                    </form>
                  </Popover.Panel>
                </Transition>
              </Popover>
            </Popover.Group>
          </div>
        </section>
      </div>
    </div>
  );
};
